import React, { FC } from 'react';
import { X } from 'react-bootstrap-icons';
import style from '../../../styles/components/modal.module.css';

type Props = {
  onClick: () => void
}

const GeneralModalClosingBtn: FC<Props> = ({ onClick }) => {

  return (
    <button onClick={onClick} className={style.closingModalBtn}>
      <X
        title='סוגר חלונית'
        className={style.closingModalBtnIcon} />
    </button>
  );
}

export default GeneralModalClosingBtn;